import { useFormContext } from "../../context/form-context"
import { hasIcons, Icon } from "./icon"

export const Summary = (props) => {
  const { showStep, storedValues } = useFormContext()

  return (
    <>
      {props.sections.map((section) => {
        return (
          <div key={section.id} class="summary-container">
            <h2 class="summary-heading">
              {section.title}
              {section.step
                ? <button
                    class="button edit-button"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault()
                      showStep(0, section.step)
                    }}
                  >
                    <span>{gettext("edit")}</span>
                    <Icon name="pencil" />
                  </button>
                : null}
            </h2>
            <div class="summary-list">
              {section.includes.map((s) => {
                return storedValues
                  .filter((o) => s.id === o.name)
                  .map((input) => {
                    return (
                      <button
                        key={`${section.id}-${input.value}`}
                        type="button"
                        class={`button summary-button w-icon ${input.value}`}
                        onClick={(e) => {
                          e.preventDefault()
                          showStep(0, input.step)
                        }}
                      >
                        {input.label}
                        {hasIcons(s.id) ? <Icon name={input.value} /> : null}
                      </button>
                    )
                  })
              })}
            </div>
          </div>
        )
      })}
    </>
  )
}
